// CheckDelivery.js
import React, { useState } from 'react';
import { TextField, Button, Typography, Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const CheckDelivery = () => {
  const [pinCode, setPinCode] = useState('');
  const [deliveryInfo, setDeliveryInfo] = useState(null);

  const handleCheckDelivery = () => {
    // Mock delivery info based on pin code
    const info = {
      pinCode,
      deliveryTime: '2-4 working days',
      standardDelivery: true,
      cashOnDelivery: false,
    };
    setDeliveryInfo(info);
  };

  return (
    <Box sx={{ marginTop:2}}>
      <Typography variant="h6">Check Delivery</Typography>
      <TextField
        label="Enter Pin Code"
        value={pinCode}
        onChange={(e) => setPinCode(e.target.value)}
        variant="outlined"
        margin="normal"
      />
      <Button variant="contained" color="primary" onClick={handleCheckDelivery} sx={{ marginTop:3, marginLeft:1 }}>
        Check
      </Button>
      {deliveryInfo && (
        <Box mt={2}>
          <Typography>
            {deliveryInfo.pinCode} in {deliveryInfo.deliveryTime} for pincode
          </Typography>
          <Typography>
            {deliveryInfo.standardDelivery ? (
              <CheckIcon color="success" />
            ) : (
              <CloseIcon color="error" />
            )}
            Standard delivery is {deliveryInfo.standardDelivery ? 'available' : 'not available'}.
          </Typography>
          <Typography>
            {deliveryInfo.cashOnDelivery ? (
              <CheckIcon color="success" />
            ) : (
              <CloseIcon color="error" />
            )}
            Cash on delivery is {deliveryInfo.cashOnDelivery ? 'available' : 'not available'}.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CheckDelivery;